// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-post-js": () => import("../src/templates/post.js" /* webpackChunkName: "component---src-templates-post-js" */),
  "component---src-pages-about-js": () => import("../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-home-js": () => import("../src/pages/home.js" /* webpackChunkName: "component---src-pages-home-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-tsscalc-js": () => import("../src/pages/tsscalc.js" /* webpackChunkName: "component---src-pages-tsscalc-js" */),
  "component---src-pages-contact-mdx": () => import("../src/pages/contact.mdx" /* webpackChunkName: "component---src-pages-contact-mdx" */)
}

